import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth-context";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (loading) return;
    if (!user) {
      navigate("/login", { replace: true });
    } else {
      setReady(true);
    }
  }, [user, loading, navigate]);

  if (loading || !ready) {
    return (
      <div className="min-h-screen grid place-items-center" data-testid="protected-loader">
        <div className="flex items-center gap-3 text-muted-foreground">
          <span className="h-3 w-3 rounded-full bg-violet-400 animate-pulse" />
          <span className="font-display tracking-tight">Loading TeeBee…</span>
        </div>
      </div>
    );
  }

  return children;
}
